import React, { useState } from 'react';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';

interface CopyAllButtonProps {
  onClick: () => void;
  tooltip: string;
  disabled?: boolean;
  allFilled?: boolean;
}

export const CopyAllButton: React.FC<CopyAllButtonProps> = ({
  onClick,
  tooltip,
  disabled,
  allFilled,
}) => {
  const [showTooltip, setShowTooltip] = useState(false);

  const handleClick = () => {
    setShowTooltip(false);
    onClick();
  };

  return (
    <OverlayTrigger
      show={showTooltip}
      onToggle={setShowTooltip}
      overlay={<Tooltip>{tooltip}</Tooltip>}
    >
      <Button
        onClick={handleClick}
        variant={allFilled ? 'outline-success' : 'outline-secondary'}
        disabled={disabled || allFilled}
      >
        {allFilled ? (
          <Icon.CheckLg size={10} />
        ) : (
          <Icon.ChevronDoubleRight size={10} />
        )}
      </Button>
    </OverlayTrigger>
  );
};

interface CopySingleButtonProps {
  onClick: () => void;
  tooltip: string;
  disabled?: boolean;
  hidden?: boolean;
}

export const CopySingleButton: React.FC<CopySingleButtonProps> = ({
  onClick,
  tooltip,
  disabled,
  hidden,
}) => {
  if (hidden) {
    return null;
  }

  return (
    <OverlayTrigger overlay={<Tooltip>{tooltip}</Tooltip>}>
      <Button onClick={onClick} variant="outline-secondary" disabled={disabled}>
        <Icon.ChevronRight size={10} />
      </Button>
    </OverlayTrigger>
  );
};
